<auth-resetpwdsuccess *ngIf="resetPwdComplete"></auth-resetpwdsuccess>

<div class="" *ngIf="!resetPwdComplete">
  <div class="page-title">Password Reset</div>
  <div class="page-sub-title">Set your new password</div>
</div>

<div class="col-lg-6 col-md-8 col-sm-10 col-lg-offset-3 col-md-offset-2 col-sm-offset-1 push-up-50" *ngIf="!resetPwdComplete">
  <div class="panel-auth">
    <img class="title-img" src="/images/login-logo.jpg" />

    <h5 class="panel-title push-down-30">Please enter your new password</h5>

    <form novalidate [formGroup]="myForm" (ngSubmit)="onSubmit(myForm.value)">
      <div class="col-sm-10 col-sm-offset-1">
        <div class="profile-sec-wrap">
          <div class="panel-sub-title push-up-10">Your password must contain at least:</div>

          <div class="col-sm-6 nopadding">
            <ul class="auth-info-panel">
              <li>- Minimum 8 characters</li>
              <li>- Lowercase letters</li>
              <li>- Uppercase letters</li>
            </ul>
          </div>

          <div class="col-sm-6 nopadding">
            <ul class="auth-info-panel">
              <li>- Numbers</li>
              <li>- Special characters:</li>
              <li>&nbsp; !, @, #, $, %, ^, &</li>
            </ul>
          </div>

          <div class="clear"></div>
        </div>
      </div>

      <div class="col-sm-10 col-sm-offset-1">
        <div class="form-elem">
          <div class="form-elem-name">New Password</div>

          <div class="form-elem-field">
            <input type="password" [(ngModel)]="model.newPassword" [formControl]="myForm.controls['newPassword']" />
            <div class="mb-error-fail-wrap" *ngIf="!myForm.controls['newPassword'].valid && myForm.controls['newPassword'].touched"><div class="mb-error-fail">Password must be 8 characters or greater</div></div>
          </div>
        </div>
      </div>

      <div class="clear"></div>

      <div class="col-xs-10 col-xs-offset-1">
        <div class="form-elem">
          <div class="form-elem-name">Confirm New Password</div>

          <div class="form-elem-field">
            <input type="password" [(ngModel)]="model.confirmPassword" [formControl]="myForm.controls['confirmPassword']" />
            <div class="mb-error-fail-wrap" *ngIf="!myForm.controls['confirmPassword'].valid && myForm.controls['confirmPassword'].touched"><div class="mb-error-fail">Password Not Matching</div></div>
          </div>
        </div>
      </div>

      <div class="clear"></div>

      <div class="col-sm-8 col-sm-offset-2 push-down-20 push-up-30">
        <input class="btn-main-proceed-alt" type="submit" value="Save Password" />
      </div>

      <div class="clear"></div>
    </form>

    <div class="clear"></div>
  </div>

  <div class="clear"></div>
</div>
